<template>
  <div v-show="isRemainHintShown" class="arrival-time-remain-hint bg-yellow-10 text-orange-50 py-2 px-5 text-sm text-end">{{ remainCountText }}</div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    todayRemainMax?: number
    remainReference?: number
    remainMode?: number
    remainCount?: number
  }>(),
  {
    todayRemainMax: 0,
    remainReference: 0,
    remainMode: 0,
    remainCount: 0,
  }
)

const { t } = useI18n()

const isRemainHintShown = computed(() => props.remainMode && props.remainCount > 0 && props.todayRemainMax > 0)

const remainCountText = computed(() => {
  const hintConditions = {
    isAllEnough: props.todayRemainMax > props.remainReference && props.remainCount > props.remainReference,
    currentTimeNotEnoughOnly: props.todayRemainMax > props.remainReference && props.remainCount <= props.remainReference,
    showAllRemain: props.remainReference === 0,
  }
  const { X, Y } = { X: props.todayRemainMax, Y: props.remainCount }
  switch (true) {
    case hintConditions.isAllEnough:
      return t('all_inventory_status_plenty')
    case hintConditions.currentTimeNotEnoughOnly:
      return t('time_selection_remaining_vacancy_plenty', { remain_vacancy: Y })
    case hintConditions.showAllRemain:
    default:
      return t('time_selection_remaining_vacancy', { max_vacancy: X, remain_vacancy: Y })
  }
})
</script>

<style lang="scss" scoped></style>
